import ServiceManager from '../../service/ServiceManager';
import { data } from '../../constants/Constants';
import { getDevice } from './utilApi';
export function BuscarMetaBonificacion(CodigoDealer, CorreoElectronicoDealer, Gjahr, Monat, Vkorg) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarMetaBonificacion";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Gjahr': Gjahr,
        'dto.Monat': Monat,
        'dto.VKorg': Vkorg,
        'dto.Sistema': data.Sistema
    };
    console.log("params.data====>", params.data);
    return ServiceManager.prototype.Post(params);
}

export function BuscarMaterialPromo(CodigoDealer, CorreoElectronicoDealer, Gjahr, Monat, Vkorg, Linea) {
    const DispositivoId = getDevice();
    let params = {};
    params.url = "dealer/BuscarMaterialPromo";
    params.data = {
        'dto.CodigoDealer': CodigoDealer,
        'dto.CorreoElectronicoDealer': CorreoElectronicoDealer,
        'dto.DispositivoDealer': DispositivoId,
        'dto.Gjahr': Gjahr,
        'dto.Monat': Monat,
        'dto.VKorg': Vkorg,
        'dto.Linea': Linea,
        'dto.Sistema': data.Sistema
    };
    return ServiceManager.prototype.Post(params);
}